import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import Spacer from 'components/ui/Spacer';
import Col from 'components/ui/Col';
import Form from 'components/ui/Form';
import RadioGroup from 'components/ui/RadioGroup';
import TextBox from 'components/ui/TextBox';
import Row from 'components/ui/Row';
const StyledRadioGroup = styled(RadioGroup)``;

const FullWidthInput = styled(TextBox)`
  width: 100%;
`;

const StyledTitle = styled.span`
  font-size: 18px;
  font-family: 'Circular-Bold';
`;

const StyledItemLabel = styled.div`
  margin-bottom: 5px;
  margin-top: 8px;
`;

const ExternalPromotion = ({ values, errors, touched, setFieldValue }) => {
  const handleChange = event => {
    setFieldValue('is_external', event.target.value);
  };
  const handleVendorChange = event => {
    setFieldValue('vendor', event.target.value);
  };

  const options = [
    {
      value: true,
      label: getTranslatedString('landlordPortal.promotions.externalYes'),
    },
    {
      value: false,
      label: getTranslatedString('landlordPortal.promotions.externalNo'),
    },
  ];

  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <Col span={24}>
          <StyledTitle>
            {getTranslatedString('landlordPortal.promotions.isExternalPromotion')}
          </StyledTitle>
          <StyledItemLabel>
            {getTranslatedString('landlordPortal.promotions.externalExample')}
          </StyledItemLabel>
        </Col>
        <Col span={24}>
          <Spacer mb={1}>
            <StyledRadioGroup
              name="is_external"
              options={options}
              value={values.is_external}
              onChange={handleChange}
            />
          </Spacer>

          {values.is_external && (
            <Form.Item
              label={getTranslatedString('landlordPortal.promotions.vendorLabel')}
              validateStatus={touched.vendor && errors.vendor ? 'error' : null}
              help={touched.vendor && errors.vendor}
            >
              <FullWidthInput
                placeholder={getTranslatedString('landlordPortal.promotions.vendorPlaceholder')}
                size="large"
                name="vendor"
                value={values.vendor}
                onChange={handleVendorChange}
              />
            </Form.Item>
          )}
        </Col>
      </Row>
    </Spacer>
  );
};

export default ExternalPromotion;
